/*
 * @Author: pengyong
 * @Date: 2019-09-12 18:23:32
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-04 23:37:06
 * @Description:
 * @FilePath: /exhibit/src/utils/axios.js
 */
import axios from "axios";
import qs from "qs";
import Vue from "vue";
import signUtil from "@/utils/signUtil";

axios.defaults.crossDomain = true;
axios.defaults.timeout = 30000000;

// http request拦截器
axios.interceptors.request.use(
    (config) => {
        const data = config.method === "get" ? config.params : config.data;
        const ts = Date.parse(new Date()) / 1000;

        let encryptionSecondData = {};
        let encryptionThirdData = {};
        if (config.method === "get" || config.method === "delete") {
            encryptionThirdData = { ...config.params, platform: "cloudvhall" };
            config.params = { ...config.params, platform: "cloudvhall" };
        } else {
            encryptionSecondData = { ...qs.parse(config.data) };
            // encryptionThirdData = { platform: "cloudvhall" };
        }
        const encryptionData = [encodeURIComponent(config.url), encryptionSecondData, encryptionThirdData, ts];
        config.headers["sig"] = signUtil(...encryptionData);
        config.headers["ts"] = ts;
        config.headers["Authorization"] = localStorage.getItem("token_type") + " " + localStorage.getItem("access_token");
        return config;
    },
    (error) => {
        return Promise.reject(error); 
    }
);

//http response 拦截器
axios.interceptors.response.use(
    (response) => {
        const { res, mes, errMes } = response.data;
        if (res !== 1) {
            Vue.prototype.$message.error(errMes || mes || "请求出错了");
            // 登录失效
            // if (res === 121) {
            //     Router.push("/login");
            // }
        }
        return response.data;
    },
    (error) => {
        if (error.message.indexOf("code 401") > -1) {
            // Vue.prototype.$message.error("登录失效");
            setTimeout(() => {
                window.logout();
            }, 1000);
            return Promise.reject(error);
        }
        if (error.message.indexOf("timeout of") > -1) {
            Vue.prototype.$message.error("网络请求超时");
            return Promise.reject(error);
        }
        if (error.message != "Request aborted") {
            Vue.prototype.$message.error(error.message || "请求出错了");
            return Promise.reject(error);
        }
    }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
axios.$get = function(url, params = {}, headers = {}) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                params,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    ...headers
                }
            })
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

/**
 * delete方法
 * @param {*} url
 * @param {*} params
 * @param {*} headers
 */
axios.$delete = function(url, params = {}, headers = {}) {
    return new Promise((resolve, reject) => {
        axios
            .delete(url, {
                params,
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                    ...headers
                }
            })
            .then((response) => {
                resolve(response || "");
            })
            .catch((err) => {
                reject(err);
            });
    });
};

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
axios.$post = function(url, data = {}, headers = {}) {
    let contentType = data instanceof FormData ? "multipart/form-data" : "application/x-www-form-urlencoded";
    let formatData = contentType === "application/x-www-form-urlencoded" ? qs.stringify({ ...data, platform: "cloudvhall" }) : data;
    return new Promise((resolve, reject) => {
        axios
            .post(url, formatData, {
                headers: {
                    "Content-Type": contentType,
                    ...headers
                }
            })
            .then(
                (response) => {
                    resolve(response || "");
                },
                (err) => {
                    reject(err);
                }
            );
    });
};
axios.$patch = function(url, data = {}, headers = {}) {
    let contentType = data instanceof FormData ? "multipart/form-data" : "application/x-www-form-urlencoded";
    let formatData = contentType === "application/x-www-form-urlencoded" ? qs.stringify({ ...data, platform: "cloudvhall" }) : data;
    return new Promise((resolve, reject) => {
        axios
            .patch(url, formatData, {
                headers: {
                    "Content-Type": contentType,
                    ...headers
                }
            })
            .then(
                (response) => {
                    resolve(response || "");
                },
                (err) => {
                    reject(err);
                }
            );
    });
};
export default axios;



// WEBPACK FOOTER //
// ./src/utils/axios.js